import {
    Dialog,
    DialogContent,
    Button,
    DialogTitle,
    DialogActions,
    IconButton,
    Grid,
} from '@material-ui/core';
import {Close} from '@material-ui/icons';
import {useTheme} from '@material-ui/core/styles';
import {AutoField} from 'components/forms/fields';
import {useNonPersistentFormMethods} from 'components/forms/hooks';
import {H6} from 'components/TypographyShortcuts';
import {UserContext} from 'context/UserContext';
import {useState} from 'react';
import {useContext} from 'react';
import {FormProvider} from 'react-hook-form';
import fields from './fields';
import InfoModal from 'components/widgets/tooltips/InfoModal';
import content from 'components/widgets/tooltips/InfoModalContent';

const MMLDFormFields = () => (
    <Grid container spacing={2}>
        <Grid item xs={11}>
            <AutoField field={fields.lastName} name='lastName' />
        </Grid>
        <Grid item xs={11}>
            <AutoField field={fields.refNumber} name='refNumber' />
        </Grid>
        <Grid item xs={1}>
            <InfoModal content={content.mmcrefnum} />
        </Grid>
    </Grid>
);

const MMLDDialog = () => {
    const [open, setOpen] = useState(false);
    const {user} = useContext(UserContext);
    const theme = useTheme();
    const methods = useNonPersistentFormMethods({
        initialValues: {lastName: user?.lastName, refNumber: null},
        schema: {
            lastName: fields.lastName.validation,
            refNumber: fields.refNumber.validation,
        },
    });
    const {errors} = methods;
    const onSubmit = e => {
        e.preventDefault();
        if (Object.keys(errors).length === 0) {
            alert(methods.getValues());
        }
    };
    return (
        <>
            <Button
                onClick={() => setOpen(true)}
                data-cy='add-mmld-button'
                variant='contained'
                color='primary'
                fullWidth
            >
                Add MMC
            </Button>
            <FormProvider {...methods}>
                <Dialog open={open} maxWidth='xs' fullWidth>
                    <form onSubmit={methods.handleSubmit(onSubmit)}>
                        <DialogTitle>
                            <H6>Add MMC</H6>
                            <IconButton
                                onClick={() => setOpen(false)}
                                style={{
                                    position: 'absolute',
                                    right: theme.spacing(1),
                                    top: theme.spacing(1),
                                }}
                            >
                                <Close />
                            </IconButton>
                        </DialogTitle>
                        <DialogContent>
                            <MMLDFormFields />
                        </DialogContent>
                        <DialogActions
                            style={{justifyContent: 'center', paddingBottom: '1rem'}}
                        >
                            <Button
                                color='secondary'
                                variant='contained'
                                type='submit'
                            >
                                Easy Lookup
                            </Button>
                        </DialogActions>
                    </form>
                </Dialog>
            </FormProvider>
        </>
    );
};

export default MMLDDialog;
export {fields, MMLDFormFields};
